/* ballot_requests.js — live admin list of homeowner ballot replacement
   requests that have not yet been turned into a resend.

   Subscribes to BallotRequestsChannel, which only says THAT something changed.
   The list is then re-read from the server and swapped in, so the markup lives
   in one place (views/dashboards/ballot_requests.html.erb) and a burst of
   changes costs one re-read. Same shape as resend_required.js. */
document.addEventListener('turbolinks:load', () => {
  const panel = document.getElementById('ballot-requests');
  if (!panel) return;
  if (panel.dataset.subscribed === 'true') return;

  const list         = document.getElementById('br-list');
  const empty        = document.getElementById('br-empty');
  const countEl      = document.getElementById('br-count');
  const orderCountEl = document.getElementById('br-order-count');
  const dotEl        = document.getElementById('br-live-dot');
  const labelEl      = document.getElementById('br-live-label');
  const badgeEl      = document.getElementById('br-live-badge');
  if (!list) return;

  function setLive(isLive) {
    if (!dotEl || !labelEl || !badgeEl) return;

    dotEl.className = isLive ? 'w-1.5 h-1.5 rounded-full bg-emerald-500' : 'w-1.5 h-1.5 rounded-full bg-gray-400';
    labelEl.textContent = isLive ? 'Live' : 'Offline';
    badgeEl.className = isLive
      ? 'inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200'
      : 'inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gray-100 text-gray-500 border border-gray-200';
  }

  function refreshCounts(serverCount) {
    const orders = list.querySelectorAll('.br-order').length;

    if (countEl) {
      countEl.textContent = (typeof serverCount === 'number')
        ? serverCount
        : list.querySelectorAll('.br-row').length;
    }
    if (orderCountEl) orderCountEl.textContent = orders;
    if (empty) empty.classList.toggle('hidden', orders > 0);
  }

  if (!window.App || !window.App.cable) {
    setLive(false);
    return;
  }

  function fetchList() {
    return fetch(window.location.href, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then((response) => {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then((html) => {
        const fresh = new DOMParser().parseFromString(html, 'text/html');
        if (!fresh.getElementById('br-list')) throw new Error('list missing');
        return fresh;
      });
  }

  let connection = 0;
  let reading = false;
  let again = false;
  let timer = null;

  function refresh() {
    if (reading) {
      again = true;
      return;
    }

    const mine = connection;
    reading = true;
    again = false;

    fetchList()
      .then((fresh) => {
        if (mine !== connection) return;

        const freshCount = fresh.getElementById('br-count');
        list.innerHTML = fresh.getElementById('br-list').innerHTML;
        refreshCounts(freshCount ? parseInt(freshCount.textContent, 10) : undefined);
        setLive(true);
      })
      .catch(() => {
        if (mine === connection) setLive(false);
      })
      .then(() => {
        reading = false;
        if (again && mine === connection) refresh();
      });
  }

  function refreshSoon() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 300);
  }

  function stop() {
    connection += 1;
    again = false;
    clearTimeout(timer);
    setLive(false);
  }

  const subscription = window.App.cable.subscriptions.create('BallotRequestsChannel', {
    connected() {
      connection += 1;
      refresh();
    },

    disconnected() {
      stop();
    },

    rejected() {
      stop();
    },

    received(data) {
      if (!data || data.type !== 'ballot_requests_changed') return;

      refreshSoon();
    }
  });

  panel.dataset.subscribed = 'true';

  document.addEventListener('turbolinks:before-render', () => {
    stop();
    subscription.unsubscribe();
    panel.dataset.subscribed = 'false';
  }, { once: true });
});
